module.exports = __webpack_public_path__ + "mg.5ecf725f3468ba3ae3b9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mg.svg
// module chunks = styles